import { __ } from "@wordpress/i18n"
import { Fragment, useMemo, useState } from "react";
import SbUtils from "../../Utils/SbUtils";
import Button from "../Common/Button";
import SettingsScreenContext from "../Context/SettingsScreenContext";
import BottomUpsellBanner from "../Global/BottomUpsellBanner";
import Header from "../Global/Header";
import SettingSectionOutput from "./Settings/SettingSectionOutput";
import ManageProUpgrade from "./Settings/Sections/ManageProUpgrade";
import WPConsentBanner from "./Settings/Sections/WPConsentBanner";

const SettingsPage = ({ editorTopLoader, editorNotification, editorConfirmDialog, connectSourceModal, apiKeyModal, allowedTiers, isPro, upsellModal, apis, apiLimits, noticeBar, noticeBarMemo, proLicenseMemo }) => {
    const sbSettings = window.sb_customizer;
    const sbCustomizer = window.sb_customizer;
    sbSettings.settingsData = Object.values(sbSettings.settingsData);
    const urlParams = new URLSearchParams(window.location.search);
    sbSettings.currentTab = urlParams.get('view') ? urlParams.get('view') : sbSettings.settingsData[0].id;
    const isSocialWallActive = sbCustomizer?.isSocialWallActive && sbCustomizer?.isSocialWallActive ? true : false;
    const socialWallLinks = sbCustomizer?.socialWallLinks ?? [];

    const [pluginSettings, setPluginSettings] = useState(sbSettings.pluginSettings);
    const settingsPage = useMemo(
        () => ({ pluginSettings, setPluginSettings }),
        [pluginSettings, setPluginSettings]
    );


    const [sourcesList, setSourcesList] = useState(sbSettings.sourcesList || []);
    const sources = useMemo(
        () => ({ sourcesList, setSourcesList }),
        [sourcesList, setSourcesList]
    );

    const [currentTab, setCurrentTab] = useState(SbUtils.findElementById(sbSettings.settingsData, 'id', sbSettings.currentTab));
    const tab = useMemo(
        () => ({ currentTab, setCurrentTab }),
        [currentTab, setCurrentTab]
    );

    const savePluginSettings = () => {
        const formData = {
            action: 'sbtt_update_global_settings',
            settings: JSON.stringify(settingsPage.pluginSettings)
        },
            notificationsContent = {
                success: {
                    icon: 'success',
                    text: __('Settings saved succesfully', 'sb-customizer')
                }
            }
        SbUtils.ajaxPost(
            sbSettings.ajaxHandler,
            formData,
            (data) => { //Call Back Function

            },
            editorTopLoader,
            editorNotification,
            notificationsContent
        )

    }

    const [pluginNotices, setPluginNotices] = useState(sbCustomizer.pluginNotices || []);
    const globalNotices = useMemo(
        () => ({ pluginNotices, setPluginNotices }),
        [pluginNotices, setPluginNotices]
    );

    return (
        <SettingsScreenContext.Provider
            value={{
                sbCustomizer,
                sbSettings,
                sources,
                editorTopLoader,
                editorNotification,
                editorConfirmDialog,
                apiKeyModal,
                apis,
                noticeBarMemo,
                noticeBar,
                settingsPage,
                connectSourceModal,
                apiLimits,
                globalNotices,
                allowedTiers,
                isPro,
                upsellModal,
                isSocialWallActive,
                socialWallLinks,
                proLicenseMemo
            }}
        >
            <Header
                className='sb-dashboard-header'
                heading={__('Settings', 'sb-customizer')}
                editorTopLoader={editorTopLoader}
                topNoticeBar={noticeBar.topNoticeBar}
                setTopNoticeBar={(e) => {
                    noticeBar.setTopNoticeBar(e)
                }}
            />

            <section className='sb-full-wrapper sb-fs sb-fs'>
                {
                    sbCustomizer?.adminNoticeContent !== null &&
                    <section className='sb-fs'
                        dangerouslySetInnerHTML={{ __html: sbCustomizer?.adminNoticeContent }}></section>
                }
                <div className='sb-dashboard-heading sb-fs'>
                    <h2 className='sb-h2'>{__('Settings', 'sb-customizer')}</h2>
                </div>

                <div className='sb-settings-ctn sb-fs'>
                    <div className='sb-settings-tabs-ctn sb-fs'>
                        <div className='sb-settings-tabs'>
                            {
                                sbSettings.settingsData.map(sTab => {
                                    return (
                                        <div
                                            className='sb-settings-tab sb-text sb-bold'
                                            key={sTab.id}
                                            data-active={sTab.id === tab.currentTab.id}
                                            onClick={() => {
                                                setCurrentTab(sTab)
                                                // update view query param.
                                                const urlParams = new URLSearchParams(window.location.search);
                                                urlParams.set('view', sTab.id);
                                                window.history.pushState({}, '', `${window.location.pathname}?${urlParams}`);
                                            }}
                                        >
                                            {sTab.name}
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className='sb-settings-save-ctn'>
                            <Button
                                type='primary'
                                size='medium'
                                icon='success'
                                text={__('Save Changes', 'sb-customizer')}
                                onClick={() => {
                                    savePluginSettings()
                                }}
                            />
                        </div>
                    </div>

                    <div className='sb-settings-sections-ctn sb-fs'>
                        {
                            tab.currentTab &&
                            Object.keys(tab.currentTab?.sections).map((secInd) => {
                                const section = tab.currentTab?.sections[secInd];
                                return (
                                    ((section?.isProSetting === undefined && section?.isFreeSetting === undefined)
                                        || (section?.isProSetting && isPro) || (section?.isFreeSetting && !isPro)) &&
                                    <Fragment key={secInd}>
                                        <div
                                            className='sb-settings-section-ctn sb-fs'
                                            data-bottom={section.separator === true}
                                            data-type={section.type}
                                            data-layout={section.layout}
                                        >
                                            <div className='sb-settings-section-label'>
                                                {section.heading && <h4 className='sb-h4 sb-fs'>{section.heading}</h4>}
                                                {section.description && <span className='sb-small-p sb-fs'>{section.description}</span>}
                                            </div>
                                            <div className='sb-settings-section-content'>
                                                <div className='sb-settings-section-input sb-fs'>
                                                    {section.inputDescription && <span className='sb-small-p sb-fs'>{section.inputDescription}</span>}
                                                    {
                                                        <SettingSectionOutput
                                                            section={section}
                                                        />
                                                    }
                                                    {section.info && <span className='sb-text-small sb-dark2-text sb-fs' dangerouslySetInnerHTML={{ __html: section.info }}></span>}
                                                </div>
                                            </div>
                                            {
                                                (section.type === 'licensekey' && isPro) &&
                                                <ManageProUpgrade/>
                                            }
                                        </div>
                                        {
                                            section.type === 'gdpr' &&
                                            <WPConsentBanner
                                                sbCustomizer={sbCustomizer}
                                                editorNotification={editorNotification}
                                                editorTopLoader={editorTopLoader}
                                            />
                                        }
                                    </Fragment>
                                )
                            })
                        }
                    </div>

                    <div className='sb-fs'>
                        <div className='sb-settings-save-ctn'>
                            <Button
                                type='primary'
                                size='medium'
                                icon='success'
                                text={__('Save Changes', 'sb-customizer')}
                                onClick={() => {
                                    savePluginSettings()
                                }}
                            />
                        </div>
                    </div>
                    <BottomUpsellBanner
                        hidePro={false}
                    />
                </div>
            </section>
        </SettingsScreenContext.Provider>
    )
}

export default SettingsPage;